import { createModel } from '@rematch/core';

import { ReferenceDataState } from './referenceData.model';
import { RootModel } from '../root';
import reducers from './referenceData.reducer';
import effects from './referenceData.effects';

const initialState: ReferenceDataState = {
  phonePrefixes: [],
  countryCodes: [],
  countyCodes: [],
  addressTypes: []
};

const referenceDataModel = createModel<RootModel>()({
  state: initialState,
  reducers,
  effects
});

export default referenceDataModel;
